import { render, staticRenderFns } from "./DefenseGameController.vue?vue&type=template&id=6a588d33&scoped=true&"
import script from "./DefenseGameController.vue?vue&type=script&lang=js&"
export * from "./DefenseGameController.vue?vue&type=script&lang=js&"
import style0 from "./DefenseGameController.vue?vue&type=style&index=0&id=6a588d33&prod&lang=css&"
import style1 from "./DefenseGameController.vue?vue&type=style&index=1&id=6a588d33&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a588d33",
  null
  
)

export default component.exports